import { lazy } from "react";
import { Navigate, createBrowserRouter, useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import PageRouteList from "./RouteList";
import { globalStorage } from "./helpers";
import ProtectedRoute from "./components/ProtectedRoute";

const MainLayout = lazy(() => import("./layouts/mainLayout"));
const LoginPage = lazy(() => import("./pages/login"));
const ChooseUnitPage = lazy(() => import("./pages/unit"));

const GetAccessToken = () => Cookies.get("fin_access_token");
const GetRefreshToken = () => Cookies.get("fin_refresh_token");
const IsAuthenticated = () => !!GetAccessToken();

export const RequireAuth = ({ children }) => {
  const { pathname } = useLocation();
  let auth = IsAuthenticated();
  if (!auth) {
    Cookies.remove("fin_access_token");
    Cookies.remove("fin_unit_data");
    Cookies.remove("fin_unit_name")
    Cookies.remove("fin_organization_id")
    globalStorage.removeItem("fin_user_data");
    globalStorage.removeItem("fin_menu_data");
    globalStorage.removeItem("fin_units");
    Cookies.remove("fin_refresh_token");
    return <Navigate to="/login" state={{ prev: pathname }} />;
  }

  if (GetRefreshToken()) {
    try {
      const tokens = Cookies.get("fin_access_token");
      const expires = (tokens.expires_in || 2 * 60 * 60) * 1000;
      const inOneHour = new Date(new Date().getTime() + expires);
      Cookies.set("fin_access_token", tokens, { expires: inOneHour });
      Cookies.set("fin_refresh_token", "refresh_token");

      return children;
    } catch (error) {
      Cookies.remove("fin_access_token");
      Cookies.remove("fin_unit_data");
      Cookies.remove("fin_unit_name")
      Cookies.remove("fin_organization_id")
      globalStorage.removeItem("fin_user_data");
      globalStorage.removeItem("fin_menu_data");
      globalStorage.removeItem("fin_units");
      Cookies.remove("fin_refresh_token");
      return <Navigate to="/login" state={{ from: location }} />;
    }
  }

  return children;
};

export default function PageRoutes() {
  const routeList = PageRouteList().RouteList;

  // Wrap each route with ProtectedRoute for permission checking
  const protectedRouteList = routeList.map(route => {
    const Component = route.element;
    const protectedRoute = {
      ...route,
      element: (
        <ProtectedRoute>
          <Component />
        </ProtectedRoute>
      ),
    };

    // Handle nested routes if any
    if (route.children && route.children.length > 0) {
      protectedRoute.children = route.children.map(childRoute => {
        const ChildComponent = childRoute.element;
        return {
          ...childRoute,
          element: (
            <ProtectedRoute>
              <ChildComponent />
            </ProtectedRoute>
          ),
        };
      });
    }

    return protectedRoute;
  });

  const Router = createBrowserRouter([
    {
      path: "/login",
      element: <LoginPage />,
    },
    {
      path: "/pilih-unit",
      label: "Pilih Unit",
      element: (
        <RequireAuth>
          <ChooseUnitPage />
        </RequireAuth>
      ),
    },
    {
      path: "/",
      element: (
        <RequireAuth>
          <MainLayout />
        </RequireAuth>
      ),
      children: protectedRouteList,
    },
  ]);
  return { Router };
}
